import PropTypes from "prop-types"

import withHeader from "areas/header/hoc/with-header"
import Button from "components/ui/button"
import { cn } from "styles/utils"

const BurgerMenu = ({ showMenu, toggleMenu }) => {
  return (
    <Button
      aria-controls="mobile-menu"
      aria-expanded={showMenu}
      aria-haspopup="true"
      aria-label="Menu"
      className="desktop:ml-0 tablet:size-24 large:hidden size-18 ml-24 bg-white"
      data-cy="header-menu-icon-mobile"
      id="js_menu_toggle"
      onClick={() => toggleMenu(showMenu)}
    >
      <div
        className={cn(
          "tablet:w-24 w-18 absolute block h-2 bg-black transition-all duration-200 ease-in-out",
          "tablet:before:w-24 before:w-18 before:absolute before:-top-7 before:block before:h-2 before:bg-black before:transition-all before:duration-200 before:ease-in-out",
          "tablet:after:w-24 after:w-18 after:absolute after:top-7 after:block after:h-2 after:bg-black after:transition-all after:duration-200 after:ease-in-out",
          showMenu &&
            "bg-transparent before:top-0 before:rotate-45 after:top-0 after:-rotate-45"
        )}
      />
    </Button>
  )
}

BurgerMenu.propTypes = {
  showMenu: PropTypes.bool,
  toggleMenu: PropTypes.func,
}

export default withHeader(BurgerMenu)
